export const enum InvitationStep {
  // We are doing A/B tests for the invitation flow, and the number of steps could change.
  // If it doesn't, this const will be removed at the end of the test
  Default = 0,
}
